import React, {useEffect, useRef} from 'react';
import objeler from './objeler';

const Footer = (props) => {
    const footer = useRef(null);
    useEffect(() => {
            objeler.Footer = {Height: footer.current.clientHeight};
        },
        [
            () => {
                objeler.Footer = {Height: footer.current.clientHeight};
            }
        ]);
    return (
        <footer className="font-sans w-full text-center border-t border-grey-lighter p-0 bg-grey-lightest text-xs "
                rmthumb="1">
            <div className="flex items-center justify-between flex-wrap bg-blue-dark p-0.5 shadow"
                 id="footer"
                 ref={footer}
            >
                <div className=" text-left " style={{width: '40%'}}>
                    {(() => {
                        if (props.footerText != null)
                            return (
                                <React.Fragment>
                                    <span className="ml-2   text-gray-400     text-xs "> Clipboard :&nbsp;</span>
                                    {props.footerText}
                                </React.Fragment>)
                    }).call(this)
                    }
                </div>
                <div
                    style={{width: '20%', whiteSpace: 'nowrap'}}
                >
                </div>
                <div style={{width: '40%'}} className=" text-right ">
          <span className="ml-2   text-gray-400     text-xs "> Current View :&nbsp;
          </span>
                    {'%' + Math.round(props.scaleNumber * 10000) / 100}
                </div>
            </div>
        </footer>
    );
}
export default Footer;